import { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from '../ui/Button';
import { BookingModal } from '../ui/BookingModal';

export const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isBookingModalOpen, setIsBookingModalOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled ? 'bg-brand-dark/80 backdrop-blur-md border-b border-brand-border' : 'bg-transparent'
        }`}
        aria-label="Main navigation"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-20">
            <div className="flex items-center space-x-3">
              <img src="/logo-icon.png" alt="North Forge" className="w-10 h-10" />
              <span className="text-2xl font-bold text-white tracking-tight font-display">North Forge</span>
            </div>

            <div className="hidden md:flex items-center space-x-8">
              <a href="#services" className="text-slate-300 hover:text-white transition-colors font-sans">Services</a>
              <a href="#process" className="text-slate-300 hover:text-white transition-colors font-sans">Process</a>
              <a href="#about" className="text-slate-300 hover:text-white transition-colors font-sans">About</a>
              <a href="#results" className="text-slate-300 hover:text-white transition-colors font-sans">Results</a>
              <Button variant="primary" size="sm" onClick={() => setIsBookingModalOpen(true)}>Book a Strategy Call</Button>
            </div>

            <div className="md:hidden">
              <button
                onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                className="text-slate-300 hover:text-white"
                aria-label={isMobileMenuOpen ? 'Close menu' : 'Open menu'}
                aria-expanded={isMobileMenuOpen}
              >
                {isMobileMenuOpen ? <X /> : <Menu />}
              </button>
            </div>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden bg-brand-dark border-b border-brand-border">
            <div className="px-4 pt-2 pb-3 space-y-1">
              <a href="#services" className="block px-3 py-2 text-slate-300 hover:text-white hover:bg-brand-base rounded-md font-sans">Services</a>
              <a href="#process" className="block px-3 py-2 text-slate-300 hover:text-white hover:bg-brand-base rounded-md font-sans">Process</a>
              <a href="#about" className="block px-3 py-2 text-slate-300 hover:text-white hover:bg-brand-base rounded-md font-sans">About</a>
              <a href="#results" className="block px-3 py-2 text-slate-300 hover:text-white hover:bg-brand-base rounded-md font-sans">Results</a>
              <div className="pt-4">
                <Button variant="primary" className="w-full" onClick={() => {
                  setIsMobileMenuOpen(false);
                  setIsBookingModalOpen(true);
                }}>Book a Strategy Call</Button>
              </div>
            </div>
          </div>
        )}
      </nav>

      <BookingModal isOpen={isBookingModalOpen} onClose={() => setIsBookingModalOpen(false)} />
    </>
  );
};
